var _defs, _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-e6e4542a-73f4-41f1-8f13-a6588bb7f4ec",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-2123226e-547f-48bd-b310-59011acd8478 {\n        fill: #f2f2f2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-2123226e-547f-48bd-b310-59011acd8478",
    d: "M15.34,22.8l-2.59-3.45-1.87,2.86c-.3.46-.92.59-1.38.29-.46-.3-.59-.92-.29-1.38l3.43-5.24,2.48,3.3,4.08-7.09,3.7,7.42c.25.49.05,1.09-.45,1.34-.5.25-1.09.05-1.34-.45l-2.04-4.08-3.73,6.49Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "uuid-2123226e-547f-48bd-b310-59011acd8478",
    cx: 11.59,
    cy: 11.36,
    r: 2.19
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/Image.f1829e329f17bdcc1f06a1de3b5bc752.svg";
export { ForwardRef as ReactComponent };